import { Box, Text } from '@rsos/base-components';
import AudioPlayer from '../AudioPlayer';
import IncidentSummary from '../tabs/TranscriptTab/IncidentSummary';
import TranscriptViewer from '../tabs/TranscriptTab/TranscriptViewer';
import type { TranscriptionStateCall } from '../tabs/TranscriptTab/transcriptionSlice/transcriptionSlice.types';

interface TranscriptHistoryDetailsProps {
  callerId: string;
  transcription: TranscriptionStateCall | null;
}

const TranscriptHistoryDetails = ({
  callerId,
  transcription,
}: TranscriptHistoryDetailsProps) => {
  if (!transcription) {
    return (
      <Text textAlign="center" color="secondaryText">
        Select a recent transcript to view details.
      </Text>
    );
  }

  return (
    <Box gridRowGap="12px">
      <AudioPlayer callerId={callerId} transcriptionOverride={transcription} />
      <IncidentSummary
        callerId={callerId}
        transcriptionOverride={transcription}
      />
      <TranscriptViewer
        callerId={callerId}
        isTranscriptMaximized={false}
        transcriptionOverride={transcription}
        readOnly
      />
    </Box>
  );
};

export default TranscriptHistoryDetails;
